import React from 'react'
import Img from "gatsby-image";

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class ArlingtonLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Arlington, VA" />
        <LocationMicroNav />

        <LocationContent 
          category="Promoting Ridership" 
          title="The Kids are Alright"
          story='The Youth Bike Summit is structured around the idea that children can become leaders in bicycle advocacy and help push for social change. The 2017 Summit attracted a diverse mix of participants, and featured a number of youth presenters who spoke to topics from how racing helps teach life skills and gives troubled youth a positive activity, to sexism in racing and how riding bikes can be an opportunity for transgender youth to express their authentic selves. Attendees were inspired by stories of kids who found focus and goals within bike racing, gained employment at bike shops, and were encouraged to "go beyond your neighborhoods, beyond what you know" and to fight for equity and representation for women and people of color.'
        />   
        <Img
          title="Arlington, VA 1-2"
          alt="Youth Bike Summit Conference photos"
          sizes= { this.props.data.arlingtonOneTwoImage.sizes }
        />   

        <LocationRelated 
          prevLocationName="Iowa"
          prevLocationPath="iowa"
          prevLocationImgPath= { this.props.data.arlingtonPrevImage }
          nextLocationName="St. Pete Beach, FL"
          nextLocationPath="st-pete-beach"
          nextLocationImgPath= { this.props.data.arlingtonNextImage }
        /> 
      </div>
    )
  }
}

export default ArlingtonLocation

// GraphQL query
export const ArlingtonImageQuery = graphql`
  query ArlingtonImageQuery {
    arlingtonOneTwoImage: imageSharp(id: { regex: "/PFB_ArlingtonVA_1-2/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    arlingtonPrevImage: imageSharp(id: { regex: "/PFB_IOWA/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    arlingtonNextImage: imageSharp(id: { regex: "/PFB_STPETE/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/arlington.js